import { ApiProperty } from '@nestjs/swagger'
import { IsString, Length } from 'class-validator'

export class CreateActivityStateRequestDto {
  @ApiProperty({ description: 'Code unique de l\'état', example: 'DRAFT', minLength: 2, maxLength: 64 })
  @IsString()
  @Length(2, 64)
  code!: string

  @ApiProperty({ description: 'Libellé de l\'état', example: 'Brouillon' })
  @IsString()
  label!: string
}

